module.exports = __webpack_public_path__ + "img/logo_legacy.eaf79d6d.svg";